/* eslint-disable */

import {
  Actionsheet,
  AddressEdit,
  AddressList,
  Area,
  Badge,
  BadgeGroup,
  Button,
  Card,
  Cell,
  CellGroup,
  CellSwipe,
  Checkbox,
  CheckboxGroup,
  Circle,
  Col,
  Collapse,
  CollapseItem,
  ContactCard,
  ContactEdit,
  ContactList,
  CouponCell,
  CouponList,
  DatetimePicker,
  Dialog,
  Field,
  GoodsAction,
  GoodsActionBigBtn,
  GoodsActionMiniBtn,
  Icon,
  ImagePreview,
  List,
  Loading,
  Locale,
  NavBar,
  NoticeBar,
  NumberKeyboard,
  Pagination,
  Panel,
  PasswordInput,
  Picker,
  Popup,
  Progress,
  PullRefresh,
  Radio,
  RadioGroup,
  Rate,
  Row,
  Search,
  Sku,
  Slider,
  Step,
  Stepper,
  Steps,
  SubmitBar,
  Swipe,
  SwipeItem,
  Switch,
  SwitchCell,
  Tab,
  Tabbar,
  TabbarItem,
  Tabs,
  Tag,
  Toast,
  TreeSelect,
  Uploader
} from 'vant'

const ui = Vue => {
  Vue.component(NavBar.name, NavBar)
  Vue.component(Button.name, Button)
  Vue.component(Tabbar.name, Tabbar)
  Vue.component(TabbarItem.name, TabbarItem)
  Vue.component(CellGroup.name, CellGroup)
  Vue.component(Cell.name, Cell)
  Vue.component(Field.name, Field)
  Vue.component(Area.name, Area)
  Vue.component(Popup.name, Popup)
  Vue.component(Switch.name, Switch)
  Vue.component(Checkbox.name, Checkbox)
  Vue.component(CheckboxGroup.name, CheckboxGroup)
  Vue.component(Tabs.name, Tabs)
  Vue.component(Tab.name, Tab)
  Vue.component(Search.name, Search)
  Vue.component(Picker.name, Picker)
  Vue.component(DatetimePicker.name, DatetimePicker)
  Vue.component(List.name, List)
  Vue.component(NavBar.name, NavBar)
  Vue.component(Tag.name, Tag)
  Vue.component(Panel.name, Panel)
  Vue.component(Icon.name, Icon)
  Vue.component(Radio.name, Radio)
  Vue.component(RadioGroup.name, RadioGroup)
  Vue.component(Collapse.name, Collapse)
  Vue.component(CollapseItem.name, CollapseItem)
  Vue.component(Row.name, Row)
  Vue.component(Col.name, Col)
  Vue.use(Dialog)
  Vue.use(Tag)
  Vue.use(Actionsheet)
  Vue.use(Tab).use(Tabs)
  Vue.use(Row).use(Col)
  Vue.prototype.$toast = Toast
};

export default ui



// WEBPACK FOOTER //
// ./src/common/ui.js